export const EXERCISE_SHORT_ANSWER = 'exercise-short-answer';
export const EXERCISE_SHORT_ANSWER_QUESTIONS = 'exercise-short-answer-questions';
export const EXERCISE_SHORT_ANSWER_QUESTION = 'exercise-short-answer-question';
export const EXERCISE_SHORT_ANSWER_BLANK = 'exercise_short_answer_blank';
export const PARAGRAPH_TOGGLE = 'paragraph-toggle';
export const CORRECT_ANSWERS = 'correct-answers';

export type EditorExerciseShortAnswerQuestionsOptions = {
  isReadOnly?: boolean;
  onBackWhenInComplete?: () => void;
  preparePayload?: () => void;
  findBellowByType?: (element, type) => void;
  progressList?: {
    exerciseId?: string;
    type?: string;
    userAnswers?: {
      question?: string;
      questionId?: string;
      answerId?: string;
      answerIds?: string[];
    }[];
  }[];
  color?: 'primary' | 'blue' | 'dark' | 'neutral' | 'light' | 'green' | 'red' | 'purple';
  onUpdateUserAnswerByQuestionId?: (userAnswer, questionId, isSingleAnswer) => void;
  onCheckAnswer?: (payload) => void;
  onNeedToSignIn?: () => void;
};

export const SHORT_ANSWER_PARAGRAPH_TOGGLE_TYPES = {
  GUIDE: 'short-answer-guide',
  QUESTION: 'short-answer-question',
  EXPLANATION: 'short-answer-explanation',
};
